import { CdkDragDrop, CdkDragEnd, CdkDragStart, transferArrayItem } from '@angular/cdk/drag-drop';
import { DOCUMENT } from '@angular/common';
import { Component, DestroyRef, effect, ElementRef, HostListener, inject, Inject, OnDestroy, OnInit, Renderer2, signal, TemplateRef, ViewChild, ViewEncapsulation, WritableSignal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatExpansionPanel } from '@angular/material/expansion';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatDrawer } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { CountableTimeZonePipe, DocumentPreviewTypes } from 'countable@helpers';
import { DIALOG_TYPES, DialogScheduleModel, EngagementScheduleModel, SPIN_STYLES, SpinInputModel, UserDetailModel } from 'countable@model';
import { ToastrService } from 'ngx-toastr';
import { skip, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, finalize, tap } from 'rxjs/operators';
import { BillingModel } from 'src/app/model/billing/billing.model';
import { ResizeModel } from 'src/app/model/eng/resize.model';
import { FirmModel } from 'src/app/model/firm/firm.model';
import { idleTime, modules } from 'src/app/services/app-config';
import { BillingService } from 'src/app/services/billing.service';
import { EngService } from 'src/app/services/eng.service';
import { FirmService } from 'src/app/services/firm.service';
import { ScheduleService } from 'src/app/services/schedule.service';
import { TimeTrackerService } from 'src/app/services/time-tracker.service';
import { FormattedNumberPipe } from '../../../../helpers/schedule/formatted-number.pipe';
import { ScheduleUtil } from '../../../../helpers/schedule/schedule-util';
import { AclModel } from '../../../../model/acl.model';
import { UngroupModel } from '../../../../model/tb/ungroup.model';
import { HeaderNameModel } from '../../../../model/workbook/header-name.model';
import { WbNoteModel } from '../../../../model/workbook/wb-note.model';
import { AclService } from '../../../../services/acl.service';
import { ApiService } from '../../../../services/api.service';
import { AuthService } from '../../../../services/auth.service';
import { EngApiService } from '../../../../services/eng-api.service';
import { TbApiService } from '../../../../services/tb-api.service';
import { WorkbookService } from '../../../../services/workbook.service';
import { SchedulesDialogComponent } from '../../../remote-shared/schedules/schedules-dialog/schedules-dialog.component';
import { SharedService } from '../../../shared/shared.service';
import { TrailBalanceWorkingSheetComponent } from '../trail-balance-working-sheet.component';

@Component({
  selector: 'working-balance-sheet',
  templateUrl: './working-balance-sheet.component.html',
  styleUrls: ['./working-balance-sheet.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
  providers: [FormattedNumberPipe]
})

export class BalanceSheetComponent implements OnInit, OnDestroy {

  trailbalId: any;
  isMapping: boolean = false;
  isBalanceSheetExpanded: boolean = true;
  @ViewChild('createLeadsheetDialog') createLeadsheetDialog: TemplateRef<any>;
  @ViewChild('saveLeadsheetDialog') saveLeadsheetalert: TemplateRef<any>;
  @ViewChild('creategroup') creategroupdialog: TemplateRef<any>;
  @ViewChild('ungroup') ungroupdialog: TemplateRef<any>;
  @ViewChild('saveMapNoDialog') saveMapNoalert: TemplateRef<any>;
  @ViewChild('focusInputField') focusInputField: ElementRef;
  @ViewChild('notesFSLinkingDialog') notesFSLinkingDialog: TemplateRef<any>;
  /* map parameters */
  @ViewChild('mapChild3Menu') mapChild3Menu: MatMenuTrigger;
  /* leadsheet parameters */
  TbLeadSheetId: number;
  tbMapSheetId: number;
  @ViewChild('lsChild3Menu') lsChild3Menu: MatMenuTrigger;
  @ViewChild('unMappedLSMenu') unMappedLSMenu: MatMenuTrigger;
  @ViewChild('unMappedMapMenu') unMappedMapMenu: MatMenuTrigger;
  @ViewChild('drawer') drawer: MatDrawer;
  @ViewChild(TrailBalanceWorkingSheetComponent) trailBalanceComp!: TrailBalanceWorkingSheetComponent;

  userData: UserDetailModel;
  engagementData: any;
  balanceSheetDetails: any = [];
  originalBalanceSheetDetails: any = [];
  leadSheetData: any;
  selectedTrailBLrow: any = [];
  isMove: boolean;
  isindividualRowSave: boolean = true;
  isDisplayCol: boolean = false;
  leadSheetId: any;
  mapSheetId: any;
  mapNo: any;
  leadSheetName: string;
  dialogRef: MatDialogRef<unknown, any>;
  displayedColumns: string[] = ['ID', 'Description'];
  leadsheetdisable: boolean = false;
  selectedEngagementDetails: any;
  year: number;
  isPrevyear: boolean;
  yearEnd: any;
  currentYear: any;
  previousYear: any;
  userLoginId: any;
  clientName: string;
  periodYear: string;
  engagementId: number;
  accYearEnd: number;
  sortGroup: string = 'AUTO';
  sortArray: any[] = [{'name': 'Automatic', 'value': 'AUTO'}, {'name': 'Manual', 'value': 'MAN'}];
  yearEndDetails: any = [];
  @ViewChild('multipleMoveMenu') multipleMoveMenu: MatMenuTrigger;
  @ViewChild('sortingMenu') sortingMenu: MatMenuTrigger;
  groupName: string;
  disabledGroupButton: boolean = false;
  submoduleId: number;
  disableAddGroupButton: boolean = false;
  duplicateIds = [];
  groupIds = [];
  selectedYearEnd: any;
  subChildArray: any;
  unGroupName: any;
  unGroupId: any;
  isCheckedAll: boolean = true;
  activeLsMove = false;
  activeMapMove = false;
  isDisableMoveButton: boolean = true;
  sortData = [];
  mappingColumns: string[] = ['mapno', 'mapsheetname'];
  isOutsidePanel = false;
  groupisASC: boolean = false;
  amountisASC: boolean = false;
  isDisableUpArrow: boolean = true;
  isDisableDownArrow: boolean = true;
  checkedManualData: any = [];
  groupData = [];
  headerNotesColumn1: string = '';
  headerNotesColumn2: string = '';
  headerNotesColumn3: string = '';
  isSecondColumnClicked: boolean = false;
  isThirdColumnClicked: boolean = false;
  isOldSecondColumn: string = '';
  subGroupSubModuleId: any;
  selectedYearTitle: string;
  isHideNotesToFS = false;
  footerNote: string;
  isFooterNoteEdited = false;
  oldFooterNote: string;
  headerData = [];
  connectedTo = [];
  selectedLSmenuPositions = [];
  private subject: Subject<string> = new Subject();
  lsMenuPopupHeight = 145;
  leadsheetPopupHeight = 535;//380;
  mapNumberPopupHeight = 691;
  changeInValueWRTls = 0;
  changeInValueWRTmap = 0;
  initialYaxis = 0;
  addPixel = 218;
  isSubLastIndex = false;
  isSearchExist = true;
  searchKeyword: string;
  searchText: string;
  isUnmappedLastIndex = false;
  isTotalLiabilityandEquityBorder = false;
  unmappedArray = [];
  hideMoveButton = true;
  footerNotes: any;
  disableSort = true;
  autoSortApplied = false;
  sortCheckboxLength: number;
  shortCutMenuDetails: any;
  finSubGroupid;
  pageX: any;
  pageY: any;
  finsubgroupchildId: any;
  acl: AclModel;
  isHideFooterNotesToFS = false;
  isManualGroupExists = 0;
  notes: any = [];
  isSelectAll: boolean = false;
  getlinkarray: any = [];
  notesSRc: any;
  todayYear: any;
  disablegreenbutton: boolean = true;
  hidePlusIcon: boolean = false;
  firm: FirmModel;
  billing: BillingModel;
  public isHideActionsForPY: boolean = false;
  public spinnerConfig: WritableSignal<SpinInputModel> = signal<SpinInputModel>(new SpinInputModel(null,SPIN_STYLES.LINE));
  private spinCount: number = 0;

  @HostListener('window:storage', ['$event'])
  onStorageChange(ev: StorageEvent) {
    if (ev.key == 'refreshWorkBookBS') {
      this.refreshBalanceSheet();
      setTimeout(() => {
        this.applySort(true);
      }, 1000);
    }
  }

  trackobj: { engagementsId: any; submoduleId: any; submoduleUuid: any; };
  userActivity;
  userInactive: Subject<any> = new Subject();
  private destroyRef = inject(DestroyRef);

  @HostListener('window:mousemove', ['$event'])
  @HostListener('window:resize', ['$event'])
  @HostListener('window:keydown', ['$event'])
  refreshUserState() {
    clearTimeout(this.userActivity);
    if (localStorage.getItem('timerStatus') == 'Idle') {
      this.trackerService.startTimer('Active');
    }
    this.setTimeout();
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event) {
    localStorage.setItem('isOpenWB', 'false');
  }

  private scrollInterval: any;
  private currentPointerPosition: { x: number; y: number } = {x: 0, y: 0};
  private globalListeners: (() => void)[] = [];
  private isScrolling: boolean = false;
  public selectedSchedule: WritableSignal<any> = signal<any>(null);
  public selectedSubGroup: WritableSignal<any> = signal<any>(null);
  public engagementScheduleDetails: WritableSignal<EngagementScheduleModel> = signal<EngagementScheduleModel>(new EngagementScheduleModel());
  public scheduleUtil: typeof ScheduleUtil = ScheduleUtil;
  public isAddSchedule: WritableSignal<boolean> = signal<boolean>(false);

  constructor(private authService: AuthService, private aclService: AclService, private apiService: ApiService,
              private router: Router, private sharedService: SharedService, public dialog: MatDialog, private toastr: ToastrService,
              private trackerService: TimeTrackerService,private firmService: FirmService, private billingService: BillingService, private ren: Renderer2,
              @Inject(DOCUMENT) private document: Document, private wbService: WorkbookService, private countableTimeZonePipe: CountableTimeZonePipe,
              public engService: EngService, private renderer: Renderer2,
              private tbApiService: TbApiService, private engApiService: EngApiService, private scheduleService: ScheduleService, private formattedNumberPipe: FormattedNumberPipe) {
    this.setTimeout();
    this.userInactive.subscribe(() => {
      this.trackerService.startTimer('Idle');
    });

    this.scheduleService.refresh$.pipe(takeUntilDestroyed(this.destroyRef), skip(1)).subscribe(res=>{
      this.multipleMoveMenu?.closeMenu();
      this.dialog?.closeAll();
      this.getBalanceSheetDetails(this.searchText);
      this.refreshPreview();
      this.isAddSchedule.set(false);
    })

    effect(() => {
      this.engagementScheduleDetails.set(this.scheduleService.engagementScheduleSignal());
      this.validateSchedules();
    });

    effect(() => {
      this.updateSpinnerConfig(this.scheduleService.spinner());
    });

  }

  ngOnInit() {
    this.firmService.subject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(firm => {
      if (firm) {
        this.firm = firm;
      }
    });
    this.billingService.subject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(billing => {
      if (billing) {
        this.billing = billing;
      }
    });
    this.authService.subjectUserDetail.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(detail => {
      this.userData = detail;
    });
    this.aclService.subject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(acl => {
      this.acl = acl;
    });
    localStorage.removeItem('refreshFinancialStatements-REH');
    localStorage.removeItem('refreshFinancialStatements-RE');
    localStorage.removeItem('refreshFinancialStatements-ISH');
    localStorage.removeItem('refreshFinancialStatements-IS');
    localStorage.removeItem('refreshFinancialStatements-LSG');
    localStorage.removeItem('refreshWorkBookBS');
    this.todayYear = new Date().getFullYear();
    this.engagementData = JSON.parse(localStorage.getItem('selectedEngagementObj'));
    this.selectedEngagementDetails = JSON.parse((localStorage.getItem('selectedEngagementObjCopy')));
    this.shortCutMenuDetails = JSON.parse(localStorage.getItem('shortCutMenuDetails'));
    this.accYearEnd = parseInt(this.countableTimeZonePipe.transform(this.engagementData.yearEnd, 'yyyy'));
    this.engagementId = this.engagementData.engagementsid;
    this.clientName = this.selectedEngagementDetails.clientName;
    this.periodYear = '12 months';
    this.submoduleId = JSON.parse(localStorage.getItem('workBookSubmoduleId'));
    this.trackobj = {
      'engagementsId': this.engagementData.engagementsid,
      'submoduleId': this.submoduleId,
      'submoduleUuid': localStorage.getItem('WUUID')
    };
    localStorage.setItem('timeTrackerObj', JSON.stringify(this.trackobj));
    this.trackerService.startTimer('Active');
    this.getHeaderTitles(false);
    this.getYearEndDetails();
    this.sharedService.isMovingLeadsheet.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      if (res.subscribeFrom === 'BS') {
        if (res.moveType === 'SINGLE') {
          if (res.moveFrom === 'LS') {
            this.confirmSaveLeadsheet(res.parent, res.child, res.yearType);
          } else {
            this.confirmSaveMapNo(res.parent, res.child, res.yearType);
          }
        } else {
          this.isDisableMoveButton = res.isDisableMoveButton;
          if (res.moveFrom === 'LS') {
            this.leadSheetDetail(res.child);
          } else {
            this.mapSheetData(res.child);
          }
        }
      }
    });
    this.sharedService.unAssignMapNumber.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      if (res) {
        this.mapChild3Menu.closeMenu();
        this.saveUnMappingItems(res);
      }
    });
    this.sharedService.leftSideMenuNameChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(response => {
      if (response) {
        this.getHeaderTitles();
      }
    });
    this.sharedService.hideMoveButton.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(response => {
      this.hideMoveButton = response != true;
    });
    this.sharedService.sortingPosition.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      if (res === true) {
        this.addPixel = 218;
      } else {
        this.addPixel = 0;
      }
    });
    this.sharedService.isBulkMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      if (res === 'SINGLE') {
        this.getBalanceSheetDetails(this.searchText);
        this.refreshPreview();
      } else if (res && res !== 'SINGLE') {
        this.clearSelection();
        this.getBalanceSheetDetails(this.searchText);
        this.refreshPreview();
      }
    });
    this.subject.pipe(
      // if character length greater then 2
      filter(res => res.length > 2 || res.length < 3)
      // Time in milliseconds between key events
      , debounceTime(1000)
      // If previous query is different from current
      , distinctUntilChanged()
    ).subscribe((text: string) => {
      this.filterBalanceSheetDetails(text);
    });
    this.getLinkTo();
  }

  setTimeout() {
    this.userActivity = setTimeout(() => this.userInactive.next(undefined), idleTime);
  }

  getYearEndDetails() {
    this.engService.getEngagementYearDetails(this.engagementId).subscribe(response => {
      if (response) {
        this.yearEndDetails = response;
        this.selectedYearEnd = this.yearEndDetails[0].acctyear;
        this.refreshPreview(false);
        this.getBalanceSheetDetails('');
      }
    }, () => {
      this.toastr.error('Error in getting Year End Details');
    });
  }

  getFSNotes() {
    this.isSelectAll = false;
    let jsonFileName = this.engagementId + '_notes.json';
    const uploadObj = {
      'module': modules[16],
      'firmId': this.userData.firmUserAcctId,
      'clientId': this.selectedEngagementDetails.clientfirmid,
      'engagementId': this.selectedEngagementDetails.engagementsid,
      'status': 0,
      'folderName': jsonFileName,
      'appSyncId': this.userData.useracctid,
      'extension': 'comp'
    };
    this.updateSpinnerConfig(true);
    this.apiService.getJsonData(uploadObj).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe((response: any) => {
      if (response) {
        this.notes = !response ? [] : JSON.parse(response);
        this.isHideFooterNotesToFS = this.notes.length ? true : false;

        this.notes.forEach(ele => {
          ele['isExpand'] = false;
          ele['is_checked'] = false;
          ele['highlight'] = false;
          if (ele.notes) {
            ele.notes.forEach(element => {
              element['is_checked'] = false;
              element['highlight'] = false;
            });
          }
        });

      }
    }, (error) => {
      this.notes = [];
      this.isHideFooterNotesToFS = this.notes.length ? true : false;
    });
  }

  getLinkTo() {
    this.apiService.getBalanceSheetLink(this.engagementId, this.accYearEnd).subscribe(resp => {
      if (resp) {
        this.getlinkarray = resp;
      }
      if (this.getlinkarray && this.getlinkarray.length == 1 && this.getlinkarray[0].child[0].subchild[0].finalamount == '-') {
        this.hidePlusIcon = true;
      }
    });
  }

  getBalancesheet_Notes_Link_Obj() {
    for (let i = 0; i < this.balanceSheetDetails.length; i++) {
      if(this.balanceSheetDetails[i]?.children?.length){
        for (let j = 0; j < this.balanceSheetDetails[i].children.length; j++) {
          if(this.balanceSheetDetails[i]?.children[j]?.children?.length){
            for (let k = 0; k < this.balanceSheetDetails[i].children[j].children.length; k++) {
              if(this.balanceSheetDetails[i].children[j].children[k]?.children?.length){
                for (let l = 0; l < this.balanceSheetDetails[i].children[j].children[k].children.length; l++) {
                  var indx = this.balanceSheetDetails[i].children[j].children[k].children.findIndex(x => x.chldid == this.notesSRc.finsubgroupchildId);
                  if (indx > -1) {
                    return this.balanceSheetDetails[i].children[j].children[k].children[indx];
                  }
                }
              }else{
                var indx = this.balanceSheetDetails[i].children[j].children.findIndex(x => x.chldid == this.notesSRc.finsubgroupchildId);
                if (indx > -1) {
                  return this.balanceSheetDetails[i].children[j].children[indx];
                }
              }
            }
          }
        }
      }
    }
  }

  get_NotesSrc_Obj(event) {
    for (let i = 0; i < this.getlinkarray.length; i++) {
      for (let j = 0; j < this.getlinkarray[i].child.length; j++) {
        if (this.getlinkarray[i].child[j].subchild.find(x => x.finsubgroupchildId == event.chldid)) {
          return this.getlinkarray[i].child[j].subchild.find(x => x.finsubgroupchildId == event.chldid);
        }
      }
    }
  }

  getCheckedNotes() {
    var selected_Records = [];
    this.notes.forEach(elem => {
      if (elem.is_checked) {
        if (elem.notes) {
          elem.notes.forEach(element => {
            selected_Records.push(element);
          });
        } else {
          selected_Records.push(elem);
        }
      } else if (elem.notes) {
        elem.notes.forEach(element => {
          if (element.is_checked) {
            selected_Records.push(element);
          }
        });
      }
    });
    return selected_Records;
  }

  saveLinkNotes() {
    var selected_Records = [];
    selected_Records = this.getCheckedNotes();
    var previously_Selected = this.getBalancesheet_Notes_Link_Obj();
    var linksavearray = [];
    selected_Records.forEach(sobj => {
      var indx = -1;
      if (previously_Selected.notes) {
        indx = previously_Selected.notes.findIndex(x => x.engNoteId == sobj.engNoteId);
      }
      var obj = {
        'engagementsId': this.engagementId,
        'finSubgroupChildId': this.notesSRc.finsubgroupchildId,
        'finSubgroupId': '',
        'submoduleId': this.submoduleId,
        'noteName': sobj.name,
        'noteId': sobj.id.toString(),
        'engNoteId': sobj.engNoteId.toString(),
        'isChanged': 0,
        'isDelete': 0,
        'loginId': this.userData.useracctid,
        'acctYear': this.accYearEnd,
        'workbookNotesId': indx > -1 ? previously_Selected.notes[indx].workbooknotesid : 0
      };
      linksavearray.push(obj);
    });
    var payload = {
      'save': linksavearray.length > 0 ? linksavearray : [{
        'engagementsId': this.engagementId,
        'finSubgroupChildId': this.notesSRc.finsubgroupchildId,
        'finSubgroupId': '',
        'submoduleId': this.submoduleId,
        'noteName': '',
        'noteId': '',
        'engNoteId': '0',
        'isChanged': 0,
        'isDelete': 0,
        'loginId': this.userData.useracctid,
        'acctYear': this.accYearEnd,
        'workbookNotesId': 0
      }]
    };
    this.apiService.saveNotesBalanceSheet(payload).subscribe(resp => {
      if (resp && resp == 'Success') {
        this.toastr.success('Successfully Completed');
        this.refreshPreview();
        this.getBalanceSheetDetails('');
      }
    });
  }

  navigateFsNotes(path: string, id: any) {
    this.router.navigate([path], {queryParams: {NoteId: id}});
  }

  changednotesLinks(event?) {
    this.resetNotesIs_Checked();
    this.notesSRc = event ? this.get_NotesSrc_Obj(event) : this.notesSRc;
    var balance_obj = event ? event : this.getBalancesheet_Notes_Link_Obj();
    this.disablegreenbutton = (balance_obj.notes && balance_obj.notes.length > 0) ? true : false;
    if (balance_obj.notes) {
      for (let k = 0; k < this.notes.length; k++) {
        for (let i = 0; i < balance_obj.notes.length; i++) {
          if (this.notes[k].engNoteId == balance_obj.notes[i].engNoteId) {
            this.is_recordChecked(k, 'category');
          } else if (this.notes[k].notes) {
            for (let j = 0; j < this.notes[k].notes.length; j++) {
              if (this.notes[k].notes[j].engNoteId == balance_obj.notes[i].engNoteId) {
                this.is_recordChecked(k, 'subcategory', j);
              }
            }
          }
        }
      }
    }
  }

  searchNotes() {
    if (this.searchKeyword != '' || this.searchKeyword.trim() != '') {
      if (this.notes.length) {
        this.notes.forEach(ele => {
          if (ele.notes && ele.notes.filter(x => x.name.toLowerCase().includes(this.searchKeyword.toLowerCase()))) {
            var indx = ele.notes.findIndex(y => y.name.toLowerCase().includes(this.searchKeyword.toLowerCase()));
            ele.isExpand = indx > -1 ? true : false;
            ele.highlight = indx > -1 ? true : false;
          } else {
            ele.isExpand = ele.name.toLowerCase().includes(this.searchKeyword.toLowerCase()) ? true : false;
            ele.highlight = ele.name.toLowerCase().includes(this.searchKeyword.toLowerCase()) ? true : false;
          }
        });
      }
    } else {
      this.notes.forEach(exp => {
        exp.isExpand = false;
        exp.highlight = false;
      });
    }

  }

  selectAll(event) {
    for (let index = 0; index < this.notes.length; index++) {
      this.notes[index].is_checked = event.checked;
      if (this.notes[index].notes) {
        this.notes[index].notes.forEach(element => {
          element.is_checked = event.checked;
        });
      }
    }

  }

  is_recordChecked(i, checkedType, j?) {
    if (checkedType == 'category') {
      this.notes[i].is_checked = !this.notes[i].is_checked;
      if (this.notes[i].notes) {
        this.notes[i].notes.forEach(element => {
          element.is_checked = this.notes[i].is_checked == true ? true : false;
        });
      }
      this.isSelectAll = this.notes.findIndex(x => x.is_checked == false) < 0 ? true : false;
    } else if (checkedType == 'subcategory') {
      this.notes[i].notes[j].is_checked = !this.notes[i].notes[j].is_checked;
      this.notes[i].is_checked = this.notes[i].notes.findIndex(x => x.is_checked == false) < 0 ? true : false;
      this.isSelectAll = this.notes.findIndex(x => x.is_checked == false) < 0 ? true : false;
    }
  }

  mappingNumber(obj, type) {
    /* if (this.isindividualRowSave) {
     obj.isMap = true;
     this.tbMapSheetId = obj.mapsheetid;
     //this.mapChild3Menu.openMenu();
     } */
    if (this.isindividualRowSave) {
      if (type = 'previous') {
        obj.isMap = true;
        this.tbMapSheetId = obj.prevmapsheetid;
      } else {
        obj.isMap = true;
        this.tbMapSheetId = obj.mapsheetid;
      }
    }
  }

  handleSearch(searchTerm: string) {
    this.subject.next(searchTerm);
  }

  //get balance sheet details
  getBalanceSheetDetails(searchTerm) {
    let search = searchTerm ? searchTerm : null;
    let balanceSheetObj = {
      'engagementsid': this.engagementData.engagementsid,
      'acctyear': parseInt(this.selectedYearEnd ? this.selectedYearEnd : this.countableTimeZonePipe.transform(this.engagementData.yearEnd, 'yyyy')),
      'searchtext': search
    };
    let finalGetObj = JSON.stringify(balanceSheetObj);
    this.updateSpinnerConfig(true);
    this.engApiService.getWFSBalanceSheet(finalGetObj).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: res => {
        if (res.status === 200) {
          let data = JSON.parse(res?.data);
          console.log('balancesheetdetails', res);
          this.balanceSheetDetails = data.groups;
          this.originalBalanceSheetDetails = data.groups;
          this.balanceSheetDetails.forEach(e => {
            e.totalname = e.totalname == 'null' ? '' : e.totalname;
          });
          this.sharedService.BlanceSheetDataFromWorkBook = JSON.parse(JSON.stringify(this.balanceSheetDetails));
          this.defaultDragging();
          this.isHideNotesToFS = data.isnotesshow == 1;
          this.isSearchExist = data.searchexist == 1;
          if (data.searchexist === 0) {
            this.toastr.warning('No records found');
          }
          this.balanceSheetDetails = this.balanceSheetDetails.length > 0 ? this.balanceSheetDetails : [];
          this.unmappedArray = this.balanceSheetDetails.filter(e => e.id == 5);
          let prev = this.balanceSheetDetails[0]['Prevgrouptotal'];
          if (prev || prev == 0) {
            this.isPrevyear = true;
          } else {
            this.isPrevyear = false;
            this.isDisplayCol = false;
          }
          this.getFSNotes();
          this.validateSchedules();
        } else {
          this.toastr.warning('Failed to load balance sheet');
        }
      }, error: e => {
        this.toastr.warning(e.error);
      }
    });
  }

  //refresh Balance sheet
  refreshBalanceSheet() {
    this.refreshPreview();
    this.multipleMoveMenu?.closeMenu();
    this.getBalanceSheetDetails(this.searchText);
    this.isHideActionsForPY = this.selectedYearEnd != this.accYearEnd;
    this.selectedTrailBLrow = [];
    this.duplicateIds = [];
    this.groupIds = [];
    if (this.isDisplayCol && this.isHideActionsForPY) {
      this.isPreviousYr();
    }
    localStorage.removeItem('refreshWorkBookBS');
  }

  // check box
  checkChange(checkeditem, completeObj, subGroupId, groupData) {
    this.isManualGroupExists = 0;
    if (completeObj && completeObj?.isuseradded) {
      this.isManualGroupExists = completeObj.isuseradded;
    }
    this.duplicateIds = [];
    if (completeObj.trialbal) {
      var objcount = completeObj.trialbal.length;
      this.subChildArray = completeObj;
      var count = 0;
      completeObj.trialbal.map(b => {
        if (b.checked == true) {
          count = count + 1;
        } else {
          count = count - 1;
        }
      });
      if (objcount == count) {
        completeObj.checked = true;
      } else {
        completeObj.checked = false;
      }
    }
    if (checkeditem.checked == true) {
      checkeditem.subGroupId = subGroupId;
      checkeditem.groupId = groupData ? groupData.id : '';
      if (completeObj.id) {
        this.groupIds.push(completeObj.id);
      }
      this.selectedTrailBLrow.push(checkeditem);
    } else {
      this.selectedTrailBLrow.map((x, index) => {
        if (x.trailbalanceid == checkeditem.trailbalanceid) {
          this.selectedTrailBLrow.splice(index, 1);
        }
      });
      if (this.groupIds) {
        this.groupIds.map((e, index) => {
          if (e == completeObj.id) {
            this.groupIds.splice(index, 1);
          }
        });
      }

    }
    //removing duplicates
    for (let i = 0; i < this.groupIds.length; i++) {
      if (this.duplicateIds.indexOf(this.groupIds[i]) === -1) {
        this.duplicateIds.push(this.groupIds[i]);
      }
    }
    if (this.duplicateIds.length > 1) {
      this.disableAddGroupButton = true;
    } else {
      this.disableAddGroupButton = false;
    }
    var unmappedcount = 0;
    this.selectedTrailBLrow.map(d => {
      if (d.mapsheetid == 0) {
        unmappedcount = unmappedcount + 1;
      }
    });
    //this.multipleUnmappedMoveMenu.closeMenu();
    // for unmapped selection
    if (unmappedcount > 0 && this.duplicateIds.length > 0) {
      this.leadsheetdisable = true;
      //this.multipleUnmappedMoveMenu.openMenu();
    } else if (unmappedcount > 0) {
      this.leadsheetdisable = true;
      //this.multipleUnmappedMoveMenu.closeMenu();
    } else {
      this.leadsheetdisable = false;
    }
    this.multipleMoveMenu.closeMenu();
    //for enable Map No. and leadsheet selection
    if (this.selectedTrailBLrow.length > 0) {
      this.multipleMoveMenu.openMenu();
      const menuDiv: HTMLElement = document.querySelector('#LSMAPDialog');
      if (menuDiv) {
        menuDiv.style.display = 'none';
      }

    } else {
      const parent: HTMLElement = document.querySelector('.cdk-overlay-connected-position-bounding-box');
      if (parent != null) {
        parent.style['margin-top'] = 0;
      }
      this.selectedLSmenuPositions = [];
      this.isDisableMoveButton = true;
      this.activeMapMove = false;
      this.activeLsMove = false;
      this.multipleMoveMenu.closeMenu();
    }
    if (this.selectedTrailBLrow.length > 0) {
      this.isindividualRowSave = false;
    } else {
      this.isindividualRowSave = true;
      this.disableLsAndMapNo();
    }
    /* if (this.selectedTrailBLrow.length == 1 || this.selectedTrailBLrow.length == 0) {
     this.enableDragging();
     } else {
     this.disableDragging();
     } */
  }

  disableLsAndMapNo() {
    this.balanceSheetDetails.forEach(p => {
      if (p.id != 4 && p.id != 6) {
        p.children.forEach(s => {
          s.isMap = false;
          if (s.children) {
            s.children.forEach(sc => {
              if (sc.trialbal) {
                sc.trialbal.forEach(ssc => {
                  ssc.isLeadSheet = false;
                  ssc.isMap = false;
                });
              }
            });
          }
        });
      }
    });
  }

  changePosition(event, checkboxLevel) {
    setTimeout(() => {
      const span: HTMLElement = document.querySelector('.cdk-overlay-connected-position-bounding-box');
      if (span != null) {
        const child: HTMLElement = document.querySelector('.cdk-overlay-pane');
        if (child) {
          child.style.left = '0';
          child.style.top = '0';
        }
        let popupSize = !this.activeMapMove && !this.activeLsMove ? this.lsMenuPopupHeight : this.activeMapMove ? this.mapNumberPopupHeight : this.leadsheetPopupHeight;
        span.style.left = (event.x + 20) + 'px';
        if ((document.documentElement.clientHeight - event.screenY - 35) >= popupSize) {
          span.style.top = ((event.pageY + 10) < 0 ? 0 : (event.pageY + 10)) + 'px';
          span.style.bottom = 'auto';
        } else {
          span.style.top = ((event.pageY - popupSize) < 0 ? 0 : (event.pageY - popupSize)) + 'px';
          span.style['margin-top'] = 0;
          span.style.top = ((event.pageY - popupSize - 25) < 0 ? 0 : (event.pageY - popupSize - 25)) + 'px';
        }

        if (!checkboxLevel.trialbal) {
          let menuStyles = {
            'left': span.style.left,
            'top': span.style.top,
            'bottom': span.style.bottom,
            'id': checkboxLevel.trailbalanceid,
            'overflow': 'auto'
          };

          let matchFound = false;
          let dialogCenterHeight = '0';
          for (let i = 0; i < this.selectedLSmenuPositions.length; i++) {
            if (this.selectedLSmenuPositions[i].id === checkboxLevel.trailbalanceid) {
              this.selectedLSmenuPositions.splice(i, 1);
              i = this.selectedLSmenuPositions.length;
              matchFound = true;
              this.activeMapMove = false;
              this.activeLsMove = false;
              this.initialYaxis = 0;
            }
          }
          if (matchFound === false && checkboxLevel.checked) {
            this.selectedLSmenuPositions.push(menuStyles);
          } else {
            dialogCenterHeight = ((document.documentElement.clientHeight - 220) / 2) - (popupSize / 2) + 220 + 'px';
            span.style.top = dialogCenterHeight;
          }

          let stylesElement = this.selectedLSmenuPositions[this.selectedLSmenuPositions.length - 1];
          if (stylesElement) {
            span.style.top = matchFound ? dialogCenterHeight : stylesElement.top;
            span.style.bottom = stylesElement.bottom;
            span.style.left = stylesElement.left;
            span.style.overflow = 'auto';
          }
        } else {
          if (!checkboxLevel.checked) {
            span.style.top = ((document.documentElement.clientHeight - 220) / 2) - (popupSize / 2) + 220 + 'px';
          }
        }
        if (this.activeMapMove) { this.changeInValueWRTmap = parseInt(span.style['top']); }
        if (this.activeLsMove) { this.changeInValueWRTls = parseInt(span.style['top']); }
      }
      const menuDiv: HTMLElement = document.querySelector('#LSMAPDialog');
      if (menuDiv) {
        menuDiv.style.display = 'flex';
      }
    }, 200);
  }

  changeUnmappedPosition(event) {
    const span: HTMLElement = document.querySelector('.unmapped-menu');
    if (span) {
      span.style.left = '50px';
      span.style.top = (event.pageY - 35) + 'px';
    }
    this.changePosition(event, '');
  }

  defaultDragging() {
    this.connectedTo = [];
    this.balanceSheetDetails.forEach(p => {
      if (p.id != 4 && p.id != 6 && p.id != 5) {
        p.children.forEach(s => {
          if (s.children) {
            s.children.forEach(sc => {
              this.connectedTo.push(sc.id);
              /* if (sc.trialbal) {
               sc.trialbal.forEach(ssc => {
               ssc.isDraggable = true;
               })
               } */
            });
          }
        });
      }
    });
  }

  removeChildItem(obj) {
    let count = this.selectedTrailBLrow.length;
    let checkedLength = this.selectedTrailBLrow.filter(e => e.checked === true);
    if (checkedLength.length == 0) {
      this.disabledGroupButton = true;
    } else {
      this.disabledGroupButton = false;
    }
    if (checkedLength.length == count) {
      this.isCheckedAll = true;
    } else {
      this.isCheckedAll = false;
    }
    this.backgroundToggle();
  }

  backgroundToggle() {
    let trailBalfalseArray = [], trailBalTrueArray = [], tbCount;
    this.balanceSheetDetails.forEach(p => {
      if (p.children) {
        p.children.forEach(c => {
          if (c.children) {
            c.children.forEach(sc => {
              tbCount = sc.trialbal.length;
              trailBalfalseArray = sc.trialbal.filter(e => e.checked == false);
              if (tbCount == trailBalfalseArray.length) {
                sc.checked = false;
              }
              trailBalTrueArray = sc.trialbal.filter(e => e.checked == true);
              if (tbCount == trailBalTrueArray.length) {
                sc.checked = true;
              }
            });
          }
        });
      }
    });
  }

  toggleLineItems(event) {
    this.selectedTrailBLrow.forEach(e => {
      if (event.checked === true) {
        e.checked = true;
        this.disabledGroupButton = false;
      } else {
        e.checked = false;
        this.disabledGroupButton = true;
      }
    });
    this.backgroundToggle();
  }

  createGroup() {
    let lineItemArray = [];
    this.selectedTrailBLrow.filter(e => {
      if (e.checked == true) {
        let lineItemObj = {
          'trailbalanceid': e.trailbalanceid,
          'sourcegroupid': e.groupId,
          'sourcesubgroupid': e.subGroupId,
          'sourcemapsheetid': e.mapsheetid,
          'sourceleadsheetid': e.leadsheetid,
          'isdelete': 0
        };
        lineItemArray.push(lineItemObj);
      }
    });
    const inputObj = {
      'group': [
        {
          'engagementsid': this.engagementId,
          'submoduleid': this.submoduleId, //need to dynamic
          'acctyear': this.selectedYearEnd,
          'groupname': this.groupName,
          'isdelete': 0,
          'loginid': this.userData.useracctid
        }
      ],
      'groupitems': lineItemArray
    };
    const stringifyObj = JSON.stringify(inputObj);
    this.updateSpinnerConfig(true);
    this.wbService.saveWbCreateGroup(stringifyObj)
      .pipe(tap(res => res.status === 200 && this.refreshPreview()),
        finalize(() => this.updateSpinnerConfig(false)))
      .subscribe({
        next: res => {
          if (res.status === 200 && res?.data) {
            this.updateSchedulesData(lineItemArray, true);
            this.multipleMoveMenu.closeMenu();
            this.groupName = '';
            this.clearSelectedData();
            this.getBalanceSheetDetails(this.searchText);
            this.getLinkTo();
            this.toastr.success('Group created successfully');

          }
        }, error: e => {
          this.groupName = '';
          this.multipleMoveMenu.closeMenu();
          this.clearSelectedData();
          this.toastr.error(e.error);
        }
      });
  }

  subGroupCheckChange(subGroupData, groupData) {
    this.isManualGroupExists = 0;
    if (subGroupData && subGroupData?.isuseradded) {
      this.isManualGroupExists = subGroupData.isuseradded;
    }
    this.duplicateIds = [];
    if (subGroupData.checked == true) {
      if (subGroupData.trialbal) {
        subGroupData.trialbal.map(x => {
          x.groupId = subGroupData?.id;
          if (x.checked) {
            if (x.checked != true) { //if item is not available in obj then push
              x.checked = true;
              this.selectedTrailBLrow.push(x);
              this.groupIds.push(subGroupData.id);
            }
          } else {
            x.checked = true;
            this.selectedTrailBLrow.push(x);
            this.groupIds.push(subGroupData.id);
          }
        });
      }
    } else {
      subGroupData.trialbal.map((y, i) => {
        y.checked = false;
        this.selectedTrailBLrow.map((b, index) => {
          if (y.trailbalanceid == b.trailbalanceid) {
            this.selectedTrailBLrow.splice(index, 1);
            this.groupIds.splice(index, 1);
          }
        });
      });
    }
    for (let i = 0; i < this.groupIds.length; i++) {
      if (this.duplicateIds.indexOf(this.groupIds[i]) === -1) {
        this.duplicateIds.push(this.groupIds[i]);
      }
    }
    if (this.duplicateIds.length > 1) {
      this.disableAddGroupButton = true;
    } else {
      this.disableAddGroupButton = false;
    }
    this.multipleMoveMenu.closeMenu();
    //for enable/disable Map No. and leadsheet selection
    if (this.selectedTrailBLrow.length > 1) {
      //this.isMove = true
      this.multipleMoveMenu.openMenu();
      const menuDiv: HTMLElement = document.querySelector('#LSMAPDialog');
      if (menuDiv) {
        menuDiv.style.display = 'none';
      }
    } else {
      //this.isMove = false
      this.multipleMoveMenu.closeMenu();
    }
    if (this.selectedTrailBLrow.length > 0) {
      this.isindividualRowSave = false;
    } else {
      this.isindividualRowSave = true;
    }
    /* if (this.selectedTrailBLrow.length == 1) {
     this.enableDragging();
     }
     else {
     this.disableDragging();
     } */
  }

  //map sheet details
  mapSheetData(value) {
    this.mapSheetId = value.mastermapsheetid;
  }

  //lead sheet details
  leadSheetDetail(value) {
    this.leadSheetId = value.leadsheetid;
  }

  // confirm save Map No.
  confirmSaveMapNo(value, MapSheet, yearType: 'PREVIOUS' | 'CURRENT') {
    this.mapNo = MapSheet.mapno;
    this.mapSheetId = MapSheet.mastermapsheetid;
    let trialbalanceId = yearType === 'PREVIOUS' ? value.prevtrailbalanceid : value.trailbalanceid;
    this.selectedTrailBLrow = [];
    var mapSheetObj = {
      'accountname': value.accountname,
      'leadsheet': value.leadsheet,
      'leadsheetid': value.leadsheetid,
      'mapno': value.mapno,
      'mapsheetid': value.mapsheetid,
      'trailbalanceid': trialbalanceId
    };
    this.selectedTrailBLrow.push(mapSheetObj);
    const dialogRef = this.dialog.open(this.saveMapNoalert, {disableClose: true});
    dialogRef.afterClosed().subscribe(result => { });
  }

  savemappingdetails(data?) {
    const parent: HTMLElement = document.querySelector('.cdk-overlay-connected-position-bounding-box');
    if (parent) {
      parent.style['margin-top'] = 0;
    }
    data ? data.isMap = false : '';
    let mapdetails = [];
    if (this.selectedTrailBLrow) {
      this.selectedTrailBLrow.map(x => {
        mapdetails.push({
          'trailbalanceid': x.trailbalanceid,
          'mapsheetid': this.mapSheetId, 'acctyear': +this.selectedYearEnd, 'loginid': this.userData['useracctid']
        });
      });
    }
    let MappingObj = {
      'tbmapping': mapdetails
    };
    let finalSaveMappingObj = JSON.stringify(MappingObj);
    this.updateSpinnerConfig(true);
    this.tbApiService.saveNewTbMapping(finalSaveMappingObj)
      .pipe(tap(res => res?.data && this.refreshPreview()),
        finalize(() => this.updateSpinnerConfig(false)))
      .subscribe({
        next: res => {
          if (res.status === 200) {
            this.clearSelectedData();
            this.mapSheetId = '';
            this.multipleMoveMenu.closeMenu();
            this.getLinkTo();
            this.getBalanceSheetDetails(this.searchText);
            this.toastr.success('Map No. moved successfully');
            this.sharedService.sendNotifySubject.next({'uuid': this.userData.useracctid, 'isfirm': 1});
          } else {
            this.toastr.error('Failed to move mapping');
          }
        }, error: e => {
          this.multipleMoveMenu.closeMenu();
          this.clearSelectedData();
          this.getBalanceSheetDetails(this.searchText);
          this.toastr.error(e.error);
        }
      });
  }

  clearSelection() {
    const parent: HTMLElement = document.querySelector('.cdk-overlay-connected-position-bounding-box');
    if (parent != null) {
      parent.style['margin-top'] = 0;
    }
    this.changeInValueWRTmap = 0;
    this.changeInValueWRTls = 0;
    this.initialYaxis = 0;
    this.groupName = '';
    this.clearSelectedData();
    this.hideMoveButton = true;
    this.balanceSheetDetails.map(x => {
      if (x.children) {
        x.children.map(y => {
          if (y.children) {
            y.children.map(z => {
              if (z.trialbal) {
                z.trialbal.map(a => {
                  if (a.checked == true) {
                    a.checked = false;
                    a.isMap = false;
                    a.isLeadSheet = false;
                  }
                });
                if (z.checked == true) {
                  z.checked = false;
                  z.isMap = false;
                  z.isLeadSheet = false;
                }
              }
            });
          } else {
            if (y.checked == true) {
              y.checked = false;
            }
          }
        });
      }
    });
    this.multipleMoveMenu.closeMenu();
  }

  //confirm save lead sheet details
  confirmSaveLeadsheet(value, LSData, yearType: 'PREVIOUS' | 'CURRENT') {
    this.leadSheetId = LSData.leadsheetid;
    let trialbalanceId = yearType === 'PREVIOUS' ? value.prevtrailbalanceid : value.trailbalanceid;
    let mapsheetId = yearType === 'PREVIOUS' ? value.prevmapsheetid : value.mapsheetid;
    this.leadSheetName = LSData.leadsheetcode + '-' + LSData.leadsheetname;
    this.selectedTrailBLrow = [];
    var leadSheetObj = {
      'accountname': value.accountname,
      'leadsheet': value.leadsheet,
      'leadsheetid': value.leadsheetid,
      'mapno': value.mapno,
      'mapsheetid': mapsheetId,
      'trailbalanceid': trialbalanceId
    };
    this.selectedTrailBLrow.push(leadSheetObj);
    this.dialogRef = this.dialog.open(this.saveLeadsheetalert, {disableClose: true});
  }

  //save leadsheet details
  saveLeadSheetdetails(data?) {
    const parent: HTMLElement = document.querySelector('.cdk-overlay-connected-position-bounding-box');
    if (parent) {
      parent.style['margin-top'] = 0;
    }
    data ? data.isLeadSheet = false : '';
    var mapdetails = [];
    if (this.selectedTrailBLrow) {
      this.selectedTrailBLrow.map(x => {
        mapdetails.push({
          'trailbalanceid': x.trailbalanceid,
          'leadsheetid': this.leadSheetId,
          'mastermapsheetid': x.mapsheetid,
          'loginid': this.userData['useracctid'],
          'submoduleid': this.submoduleId,
          'fsid': 0
        });
      });
    }
    var leadSheetObj = {
      'leadsheetchange': mapdetails
    };
    var finalSaveMappingObj = JSON.stringify(leadSheetObj);
    this.updateSpinnerConfig(true);
    this.engApiService.saveBsIsLeadSheetGrouping(finalSaveMappingObj)
      .pipe(tap(res => res?.data && this.refreshPreview()),
        finalize(() => this.updateSpinnerConfig(false)))
      .subscribe({
        next: res => {
          if (res.status === 200 && res?.data) {
            this.multipleMoveMenu.closeMenu();
            this.clearSelectedData();
            this.leadSheetId = '';
            this.getLinkTo();
            this.getBalanceSheetDetails(this.searchText);
            this.toastr.success('Leedsheet moved successfully');
            localStorage.setItem('updateProcedures', 'success');
          } else {
            this.toastr.error('Failed to move leadsheet');
            this.getBalanceSheetDetails(this.searchText);
          }
        }, error: e => {
          this.clearSelectedData();
          this.multipleMoveMenu.closeMenu();
          this.getBalanceSheetDetails(this.searchText);
          this.toastr.error(e.error);
        }
      });
  }

  clearRowSelection() {
    this.selectedTrailBLrow = [];
    this.leadSheetId = '';
  }

  UpdateBalanceSheet(objchild, type?) {
    let name: string, totalname: string;
    name = objchild.name ? objchild.name.trim() : '';
    totalname = objchild.totalname ? objchild.totalname.trim() : '';
    if (name && name.length > 250) {
      this.toastr.warning('Text length is limited to 250 characters');
      objchild.name = objchild.oldvalue ? objchild.oldvalue : '';
      this.groupData = [];
      return;
    }
    if (totalname && totalname.length > 250) {
      this.toastr.warning('Text length is limited to 250 characters');
      objchild.totalname = objchild.oldtotalname ? objchild.oldtotalname : '';
      this.groupData = [];
      return;
    }
    let fsId;
    if (type === 'PARENT') {
      fsId = objchild.id;
    } else {
      fsId = objchild.chldid;
    }
    var obj = {
      'engagementsid': this.engagementData.engagementsid,
      'acctyear': parseInt(this.selectedYearEnd ? this.selectedYearEnd : this.countableTimeZonePipe.transform(this.engagementData.yearEnd, 'yyyy')),
      'fstype': 'balanceSheet',
      'fsid': fsId,
      'currentname': objchild.oldvalue ? objchild.oldvalue : objchild.name ? objchild.name : 'null',
      'newname': objchild.name ? objchild.name : 'null',
      'ploginid': this.userData.useracctid,
      'intotalcurrentname': objchild.oldtotalname ? objchild.oldtotalname : objchild.totalname ? objchild.totalname : ' null',
      'intotalnewname': objchild.totalname ? objchild.totalname : 'null'
    };
    this.apiService.saveFsDetails(obj).pipe(
      tap(res => res && this.refreshPreview())
    ).subscribe(response => {
      if (response) {
        localStorage.setItem('updateProcedures', 'success');
        this.toastr.success('Group name updated successfully');
        this.groupData = [];
        this.getBalanceSheetDetails(this.searchText);
        if(objchild?.schedule_id){
          const path = `/name?id=${objchild.schedule_id}`;
          this.scheduleService.updateScheduleName(path, objchild?.name);
        }
      } else {
        this.toastr.warning('Failed to update group name');
      }
    }, error => {
      this.groupData = [];
      this.toastr.error(error.error);
    });
  }

  openGroupPopup() {
    this.groupName = null;
    this.isCheckedAll = true;
    const dialogRef = this.dialog.open(this.creategroupdialog, {disableClose: true});
    dialogRef.afterClosed().subscribe(result => { this.isManualGroupExists = 0; });
  }

  openunGroupPopup(obj) {
    let groupId;
    this.unGroupName = obj.name;
    groupId = obj.id.split('.');
    this.unGroupId = groupId[1];
    const dialogRef = this.dialog.open(this.ungroupdialog, {disableClose: true});
    dialogRef.afterClosed().subscribe(result => {
       if(result && obj?.trialbal?.length){
         this.updateSchedulesData(obj.trialbal, false);
       }
    });
  }

  unGroup() {
    const ungroupModel: UngroupModel = {
      engId: this.engagementId,
      subModuleId: this.submoduleId,
      year: this.accYearEnd,
      bsIsSubGroupId: this.unGroupId
    };
    this.updateSpinnerConfig(true);
    this.tbApiService.unGroup(ungroupModel)
      .pipe(tap(res => res && this.refreshPreview()),
        finalize(() => this.updateSpinnerConfig(false)))
      .subscribe({
        next: res => {
          if (res?.status === 200 && res?.data) {
            this.toastr.success('Ungrouped successfully');
            this.getBalanceSheetDetails(this.searchText);
          }
        }, error: e => {
          this.toastr.error(e.error);
        }
      });
  }

  onDragMoved(event) {
    this.dragMoved(event);
    //(cdkDragMoved)="onDragMoved($event)"
    /*
     let pixel = 0;
     let grid = this.document.getElementById('grid');
     if (event.event.pageY - 400 === grid.clientHeight)
     {

     // element is at the end of its scroll, load more content
     } */
    /* if (event.delta.y === 1) {
     pixel =+ event.event.movementY;
     this.document.getElementById('grid').scrollBy({top: pixel, behavior: 'smooth'});
     //event.event.pageY += 10;
     } else {
     pixel =- event.event.movementY;
     this.document.getElementById('grid').scrollBy({top: pixel, behavior: 'smooth'});
     //event.event.pageY -= 10;
     } */
    //Auto Scroll: event*(required), direction(horizontal or vertical), lateralTolerancePx, stepPx, everyXms
    //this.autoScrollSetup.autoScroll({'event':event,'direction':'vertical'})

  }

  dragMoved(event) {
    var edgeSize = 150;
    var timer = null;
    var viewportX = event.event.clientX;
    var viewportY = event.event.clientY;

    // Get the viewport dimensions.
    var viewportWidth = this.document.getElementById('grid').clientWidth;
    var viewportHeight = this.document.getElementById('grid').clientHeight;

    // Next, we need to determine if the mouse is within the "edge" of the
    // viewport, which may require scrolling the window. To do this, we need to
    // calculate the boundaries of the edge in the viewport (these coordinates
    // are relative to the viewport grid system).
    var edgeTop = edgeSize;
    //var edgeLeft = edgeSize;
    var edgeBottom = (viewportHeight - edgeSize); //490
    //var edgeRight = ( viewportWidth - edgeSize );

    /* var isInLeftEdge = ( viewportX < edgeLeft );
     var isInRightEdge = ( viewportX > edgeRight ); */
    var isInTopEdge = (viewportY < edgeTop + 244);
    var isInBottomEdge = (viewportY > edgeBottom + 244);
    if (isInBottomEdge) {
      this.document.getElementById('grid').scrollBy({top: 150, behavior: 'smooth'});
    }
    if (isInTopEdge) {
      this.document.getElementById('grid').scrollBy({top: -150, behavior: 'smooth'});
    }

    if (!(isInTopEdge || isInBottomEdge)) {
      clearTimeout(timer);
      return;
    }

  }

  drop(event: CdkDragDrop<any[]>, data) {
    if (!event.isPointerOverContainer) {
      console.info('Dropped outside the grid, resetting...');
      return;
    }
    let obj = {};
    if (event.previousContainer !== event.container) {
      const leadsheetId = event.container.data[0].leadsheetid;
      const mapsheetId = event.container.data[0].mapsheetid;
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
      let fid: any;
      if (data.isuseradded === 1) {
        let ids = data.chldid.split('.', 2);
        fid = ids[0] + '.' + ids[1];
      } else {
        fid = '0';
      }
      obj = {
        trailbalanceid: event.item.data.trailbalanceid,
        leadsheetid: leadsheetId,
        mastermapsheetid: mapsheetId,
        loginid: this.userData['useracctid'],
        fsid: fid,
        submoduleid: this.submoduleId
      };
      this.saveDraggingItem(obj);
    }
  }

  saveDraggingItem(obj) {
    let leadSheetObj = {
      'leadsheetchange': [obj]
    };
    let finalSaveMappingObj = JSON.stringify(leadSheetObj);
    this.updateSpinnerConfig(true);
    this.engApiService.saveBsIsLeadSheetGrouping(finalSaveMappingObj)
      .pipe(tap(res => res?.data && this.refreshPreview()),
        finalize(() => this.updateSpinnerConfig(false)))
      .subscribe({
        next: res => {
          if (res.status === 200 && res?.data) {
            this.toastr.success('Account moved successfully');
            this.getBalanceSheetDetails(this.searchText);
            this.selectedTrailBLrow = [];
            this.isindividualRowSave = true;
          } else {
            this.toastr.success('Failed to move leadsheet');
            this.getBalanceSheetDetails(this.searchText);
          }
        }, error: e => {
          this.selectedTrailBLrow = [];
          this.getBalanceSheetDetails(this.searchText);
          this.toastr.error(e.error);
        }
      });
  }

  /* Leadsheet Dropdown start */
  activeLSDropdown(obj) {

    if (this.isindividualRowSave) {
      obj.isLeadSheet = true;
      this.TbLeadSheetId = obj.leadsheetid;
      //this.lsChild3Menu.openMenu();
    }
  }

  activePreviousYearLSDropdown(obj) {
    if (this.isindividualRowSave) {
      obj.isLeadSheet = true;
      this.TbLeadSheetId = obj.leadsheetid;
      //this.lsChild3Menu.openMenu();
    }
  }

  activeUnmappedMapDropdown(obj) {
    if (this.isindividualRowSave) {
      obj.isMap = true;
      this.tbMapSheetId = obj.mapsheetid;
    }
  }

  /* Leadsheet DropDown end */

  unSavedTitle() {
    let headerTitle: string;
    headerTitle = 'Please save the data';
    this.toastr.warning(headerTitle);
  }

  isPreviousYr() {
    this.disableLsAndMapNo();
    this.isDisplayCol = !this.isDisplayCol;
  }

  getHeaderTitles(isSetKey?: boolean) {
    this.wbService.getWbHeaderNote(this.engagementId, this.submoduleId).subscribe({
      next: res => {
        if (res?.status === 200 && res?.data) {
          const results = JSON.parse(res.data);
          this.headerData = results;
          this.headerNotesColumn1 = results[0].header[0].changednameline1;
          this.headerNotesColumn2 = results[0].header[0].changednameline2;
          this.headerNotesColumn3 = results[0].header[0].changednameline3;
          this.footerNotes = results[1].note ? results[1].note[0].note : '';
          const refreshMap = this.sharedService.setRefreshOfStatement(DocumentPreviewTypes.BALANCE_SHEET);
          this.sharedService.updateFinStatement$.next(refreshMap);
          if (isSetKey == undefined) {
            localStorage.setItem('refreshFinancialStatements-BSH', 'success');
          }
        }
      }, error: e => {
        this.toastr.error(e.error);
      }
    });
  }

  // Expand and collapse all panels
  togglePannels(type: 'C' | 'E') {
    if (type === 'C') {
      this.isBalanceSheetExpanded = false;
      this.balanceSheetDetails.forEach(p => {
        p.isexpand = false;
        if (p.id != 4 && p.id != 6) {
          p.children.forEach(s => {
            s.isexpand = false;
            if (s.children) {
              s.children.forEach(sc => {
                sc.isexpand = false;
              });
            }
          });
        }
      });
    } else {
      this.isBalanceSheetExpanded = true;
      this.balanceSheetDetails.forEach(p => {
        p.isexpand = true;
        if (p.id != 4 && p.id != 6) {
          p.children.forEach(s => {
            s.isexpand = true;
            if (s.children) {
              s.children.forEach(sc => {
                sc.isexpand = true;
              });
            }
          });
        }
      });
    }
  }

  getSubGroupSortingData(data, event, isRefresh: boolean, finsubgroupchildId?) {
    this.autoSortApplied = false;
    this.pageX = event.pageX;
    this.pageY = event.pageY;
    const span: HTMLElement = document.querySelector('.sort-position');
    span.style.left = (this.pageX - 120 - this.addPixel) + 'px';
    span.style.top = (this.pageY - 65) + 'px';
    this.subGroupSubModuleId = data.submoduleid;
    this.finSubGroupid = data.id;
    this.finsubgroupchildId = finsubgroupchildId;
    // this.applySort(isRefresh);
    this.sortData = [];
    if (data?.children && data.children.length) {
      data.children.forEach(subChild => {
        if(subChild?.is_schedule_exits && subChild?.groupName && subChild?.children?.length){
          let curBal = 0;
          subChild.children.forEach(c =>{
            curBal += (c.Currbal == '-') ? 0 : this.scheduleUtil.convertToNumber(c.Currbal)
          });
          this.sortData.push({
            'finsubgroupchildId': subChild.children[0].id,
            'subgroupname': subChild?.groupName,
            'value': `${curBal}`,
            'sortvalue': this.formattedNumberPipe.transform(curBal),
            'childid': subChild.children[0]?.chldid,
            'bsissortorderid': subChild.children[0]?.bsissortorderid,
            'bsissortorderitemid': subChild.children[0]?.bsissortorderitemid,
            'submoduleid': data.submoduleid,
            'checked': this.finsubgroupchildId == subChild.children[0]?.id,
            'isuseradded': subChild.children[0]?.isuseradded ? subChild.children[0]?.isuseradded : 0,
            children: subChild?.children
          });
        }else{
          this.sortData.push({
            'finsubgroupchildId': subChild.id,
            'subgroupname': subChild.name,
            'value': (subChild.Currbal == '-') ? '0' : ((subChild.Currbal).includes('(') ? '-' + ((subChild.Currbal).replace(/[{(,)}]/g, '')) : ((subChild.Currbal).replace(/,/g, '')) + ''),
            'sortvalue': subChild.Currbal,
            'childid': subChild.chldid,
            'bsissortorderid': subChild.bsissortorderid,
            'bsissortorderitemid': subChild.bsissortorderitemid,
            'submoduleid': data.submoduleid,
            'checked': this.finsubgroupchildId == subChild.id ? true : false,
            'isuseradded': subChild?.isuseradded ? subChild.isuseradded : 0

          });
        }
      });
      this.sortingMenu.openMenu();
      this.disableSort = true;
      this.sortGroup = 'AUTO';
      this.checkedManualData = [];
      this.sortCheckboxLength = 0;
    }
  }

  applySort(isRefresh: boolean) {
    if (!this.finSubGroupid) {
      return;
    }
    const inputObj = {
      'engagementsid': this.engagementId,
      'acctyear': parseInt(this.selectedYearEnd),
      'finsubgrpid': this.finSubGroupid,
      'submoduleid': this.submoduleId
    };
    this.updateSpinnerConfig(true);
    this.apiService.getSubgroupSort(this.userData.useracctid, inputObj).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe(response => {
      if (response) {
        let res = JSON.parse(response);
        this.sortData = res;
        this.sortData.forEach(e => {
          if (e.finsubgroupchildId == this.finsubgroupchildId) {
            e.checked = true;
          }
        });
        if (isRefresh === false) {
          this.sortingMenu.openMenu();
          this.disableSort = true;
          this.sortGroup = 'AUTO';
          this.checkedManualData = [];
          this.sortCheckboxLength = 0;
        }
      }
    }, error => {
      this.toastr.error(error.error);
    });
  }

  onChangeSort(event) {
    /* this.manualSortData = [];
     this.sortData.map( e => {
     e.checked = false;
     }) */

  }

  acticeGroup(data, type: 'PARENT' | 'CHILD') {
    this.focusInput();

    this.groupData.push(data);
    if (this.groupData.length > 1) {
      this.unSavedTitle();
      this.groupData.map((x, index) => {
        if (x.id == data.id) {
          this.groupData.splice(index, 1);
        }
      });
    } else {
      if (type === 'PARENT') {
        data.isTotalEditable = true;
      } else {
        data.isEditable = true;
      }
    }
  }

  clearGroup() {
    this.groupData = [];
  }

  toggleSort(para) {
    if (para == 'group') {
      this.groupisASC = !this.groupisASC;
      if (this.groupisASC) {
        this.sortData.sort((a, b) => 0 - (a.subgroupname?.toLowerCase() > b.subgroupname?.toLowerCase() ? -1 : 1));

      } else if (!this.groupisASC) {
        this.sortData.sort((a, b) => 0 - (a.subgroupname?.toLowerCase() > b.subgroupname?.toLowerCase() ? 1 : -1));
      }

    } else if (para == 'amount') {
      this.amountisASC = !this.amountisASC;
      if (this.amountisASC) {
        this.sortData.sort(function (a, b) { return a.value - b.value; });
      } else if (!this.amountisASC) {
        this.sortData.sort(function (a, b) { return b.value - a.value; });

      }
    }

    // this.sortData.sort((a, b) => {
    // let x = parseInt(a.value.replace(/[()]/g, ''));
    // let y = parseInt(b.value.replace(/[()]/g, ''));
    // let comparison = 0;
    // if (x > y) {
    //   comparison = 1;
    // } else if (x < y) {
    //   comparison = -1;
    // }
    // return para=='group'?(this.groupisASC ? (comparison * -1) : comparison):(this.amountisASC ? (comparison * -1) :
    // comparison) });
    this.disableSort = false;
    this.autoSortApplied = true;
  }

  manualSorting(type?) {
    let totalCount = this.sortData.length;
    let checkedIndex = this.sortData.findIndex(e => e.checked);
    if (type === 'UP') {
      if (checkedIndex != 0) {
        this.move(this.sortData, checkedIndex, checkedIndex - 1);
      }
    } else {
      if (checkedIndex != totalCount - 1) {
        this.move(this.sortData, checkedIndex, checkedIndex + 1);
      }
    }
    this.disableSort = false;
  }

  //line by line sorting
  move(arr, old_index, new_index) {
    while (old_index < 0) {
      old_index += arr.length;
    }
    while (new_index < 0) {
      new_index += arr.length;
    }
    if (new_index >= arr.length) {
      var k = new_index - arr.length;
      while ((k--) + 1) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  }

  onChangeAddManualData(obj) {
    this.sortCheckboxLength = this.sortData.filter(e => e.checked === true).length;
    if (obj.checked === true) {
      this.checkedManualData.push(obj);
    } else {
      this.checkedManualData.map((x, index) => {
        if (x.finsubgroupchildId == obj.finsubgroupchildId) {
          this.checkedManualData.splice(index, 1);
        }
      });
    }
    if (this.checkedManualData.length == 0 || this.checkedManualData.length == this.sortData.length) {
      this.isDisableDownArrow = true;
      this.isDisableUpArrow = true;
      this.disableSort = true;
    } else {
      this.isDisableDownArrow = false;
      this.isDisableUpArrow = false;
      this.disableSort = false;
    }
  }

  disableSortBtn(value) {
    //autoSortApplied
    if (value === 'MAN') {
      if (this.checkedManualData.length > 0) {
        this.disableSort = false;
      } else {
        this.disableSort = true;
      }
    } else if (value === 'AUTO') {
      if (this.autoSortApplied === true) {
        this.disableSort = false;
      } else {
        this.disableSort = true;
      }
    }
  }

  onCLickSaveSorting() {
    let inputData = [];
    let sortType = this.sortGroup == 'AUTO' ? true : false;
    this.sortData.map(e => {
      if (e.checked) {
        this.finsubgroupchildId = e.finsubgroupchildId;
      }

      if(e?.children?.length){
        e.children.forEach(scheduleGroup =>{
          let obj = {
            'engagementsId': this.engagementId,
            'submoduleId': this.subGroupSubModuleId,
            'acctYear': parseInt(this.selectedYearEnd),
            'isAutomatic': sortType,//auto : true; manual: false
            'sortOrder': 'desc',
            'finSubgroupChildId': scheduleGroup?.id,
            'bsIsSortOrderId': scheduleGroup?.bsissortorderid,
            'bsIsSortOrderItemId': scheduleGroup?.bsissortorderitemid,
            'childId': scheduleGroup?.chldid || scheduleGroup?.childid,
            'loginId': this.userData.useracctid,
            'isUserAdded': scheduleGroup?.isuseradded ? scheduleGroup?.isuseradded : 0
          };
          inputData.push(obj);
        })
      }else{
        let obj = {
          'engagementsId': this.engagementId,
          'submoduleId': this.subGroupSubModuleId,
          'acctYear': parseInt(this.selectedYearEnd),
          'isAutomatic': sortType,//auto : true; manual: false
          'sortOrder': 'desc',
          'finSubgroupChildId': e.finsubgroupchildId,
          'bsIsSortOrderId': e.bsissortorderid,
          'bsIsSortOrderItemId': e.bsissortorderitemid,
          'childId': e.childid,
          'loginId': this.userData.useracctid,
          'isUserAdded': e?.isuseradded ? e.isuseradded : 0
        };
        inputData.push(obj);
      }

    });
    const inputObj = {
      'sort': inputData
    };
    this.updateSpinnerConfig(true);
    this.apiService.saveSubgroupSort(inputObj).pipe(
      tap(res => res && this.refreshPreview())
    ).subscribe(response => {
      this.updateSpinnerConfig(false);
      if (response) {
        let obj = {'submoduleid': this.subGroupSubModuleId, 'id': this.finSubGroupid};
        let event = {'pageX': this.pageX, 'pageY': this.pageY};
        this.getSubGroupSortingData(obj, event, true, this.finsubgroupchildId);
        //this.sortingMenu.closeMenu();
        // this.refreshPreview();
        this.getBalanceSheetDetails(this.searchText);
        this.toastr.success('Records sorted successfully');
        this.sortingMenu.closeMenu();
      }
    }, error => {
      this.updateSpinnerConfig(false);
      this.toastr.error(error.error);
    });
  }

  closeSort() {
    this.sortingMenu.closeMenu();
    this.finsubgroupchildId = 0;
  }

  activeMultiLs(obj, event) {
    obj.isLeadSheet = true;
    this.TbLeadSheetId = 0;
    this.isDisableMoveButton = true;
    this.hideMoveButton = true;
    const span: HTMLElement = document.querySelector('.cdk-overlay-connected-position-bounding-box');
    if (this.initialYaxis === 0) {
      this.initialYaxis = event.clientY;
    }

    if (!this.activeMapMove && !this.activeLsMove) {
      span.style['top'] = parseInt(span.style['top']) - (this.leadsheetPopupHeight - (document.documentElement.clientHeight - this.initialYaxis) - 20) + 'px';
      if (parseInt(span.style['top']) < 0) {
        span.style['top'] = '0px';
      }
      span.style['height'] = (this.mapNumberPopupHeight < (document.documentElement.clientHeight - parseInt(span.style['top'])) ? this.mapNumberPopupHeight :
        this.leadsheetPopupHeight < (document.documentElement.clientHeight - parseInt(span.style['top'])) ? this.leadsheetPopupHeight :
          (document.documentElement.clientHeight - parseInt(span.style['top']))) + 'px';
    } else {

      if (this.activeMapMove) {
        span.style['top'] = this.changeInValueWRTmap + 'px';
      } else {
        span.style['top'] = this.changeInValueWRTls + 'px';
      }
    }
    this.changeInValueWRTls = parseInt(span.style['top']);
    span.style['overflow'] = 'auto';
    this.activeLsMove = true;
    this.activeMapMove = false;
  }

  activeMultiMapNo(obj, event) {
    obj.isMap = true;
    this.tbMapSheetId = 0;

    this.isDisableMoveButton = true;
    this.hideMoveButton = true;
    const span: HTMLElement = document.querySelector('.cdk-overlay-connected-position-bounding-box');
    if (this.initialYaxis === 0) {
      this.initialYaxis = event.clientY;
    }
    span.style['overflow'] = 'auto';
    if (!this.activeMapMove && !this.activeLsMove) {
      if ((document.documentElement.clientHeight - this.initialYaxis - 35) <= this.mapNumberPopupHeight) {
        span.style['top'] = parseInt(span.style['top']) - (this.mapNumberPopupHeight - (document.documentElement.clientHeight - this.initialYaxis) - 20) + 'px';
        if (parseInt(span.style['top']) < 0) {
          span.style['top'] = '0px';
        }
        span.style['height'] = (this.mapNumberPopupHeight < (document.documentElement.clientHeight - parseInt(span.style['top'])) ? this.mapNumberPopupHeight :
          this.leadsheetPopupHeight < (document.documentElement.clientHeight - parseInt(span.style['top'])) ? this.leadsheetPopupHeight :
            (document.documentElement.clientHeight - parseInt(span.style['top']))) + 'px';
      }
    } else {
      if (this.activeMapMove) {
        span.style['top'] = this.changeInValueWRTmap + 'px';
      } else {
        span.style['top'] = this.changeInValueWRTls + 'px';
      }
    }
    this.changeInValueWRTmap = parseInt(span.style['top']);
    this.activeMapMove = true;
    this.activeLsMove = false;
  }

  saveHeaderNote() {
    const headerNameModel: HeaderNameModel = {
      subModuleId: this.submoduleId,
      engId: this.engagementId,
      changedNameLine2: this.headerNotesColumn2,
      changedNameLine3: this.headerNotesColumn3,
      isDelete: 0
    };

    this.updateSpinnerConfig(true);
    this.wbService.saveChangeWbHeaderName(headerNameModel).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: res => {
        if (res.status === 200 && res?.data) {
          this.toastr.success('Header details updated successfully');
          this.isSecondColumnClicked = false;
          this.isThirdColumnClicked = false;
          this.getHeaderTitles();
        }
      }, error: e => {
        this.toastr.error(e.error);
      }
    });
  }

  editFooterNotes() {
    this.focusInput();
    this.oldFooterNote = this.footerNotes;
    this.footerNote = this.footerNotes;
    this.isFooterNoteEdited = true;
  }

  cancelEditFooterNote() {
    this.footerNotes = this.oldFooterNote;
    this.isFooterNoteEdited = false;
  }

  saveFooterNote() {
    this.footerNote = this.footerNote.trim();
    if (!this.footerNote) {
      this.toastr.warning('Please enter the notes');
      return;
    }
    if (this.footerNote.length > 250) {
      this.toastr.warning('Text length is limited to 250 characters');
      return;
    }

    const wbNoteModel: WbNoteModel = {
      subModuleId: this.submoduleId,
      engId: this.engagementId,
      note: this.footerNote,
      isDelete: 0
    };

    this.updateSpinnerConfig(true);
    this.wbService.saveWbNote(wbNoteModel).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: res => {
        if (res.status === 200) {
          this.sharedService.isBalSheetFooterUpdate.next({'isfooterUpdated': true, 'note': this.footerNote});
          localStorage.setItem('isfooterUpdated', this.footerNote);
          this.footerNotes = this.footerNote;
          this.toastr.success('Footer details updated successfully');
          this.isFooterNoteEdited = false;
        }
      }, error: e => {
        this.toastr.error(e.error);
      }
    });
  }

  focusInput() {
    setTimeout(() => {
      this.focusInputField.nativeElement.focus();
    }, 0);
  }

  trackByRecords(index, item) {
    return index; // or item.id
  }

  trackByChild3Records(index, item) {
    return index; // or item.id
  }

  trackByChild2Records(index, item) {
    return index; // or item.id
  }

  trackByChildRecords(index, item) {
    return index; // or item.id
  }

  saveUnMappingItems(data) {
    let trialbalanceId = data.yearType === 'PREVIOUS' ? data.parent.prevtrailbalanceid : data.parent.trailbalanceid;
    let inputObject = [{
      'trailbalanceid': trialbalanceId
    }];
    var finalSaveMappingObj = JSON.stringify({'unmapping': inputObject});

    this.updateSpinnerConfig(true);
    this.tbApiService.unMap(finalSaveMappingObj)
      .pipe(tap(res => res && this.refreshPreview()),
        finalize(() => this.updateSpinnerConfig(false)))
      .subscribe({
        next: res => {
          if (res.status === 200 && res.data) {
            this.toastr.success('Unmapped successfully');
            this.getBalanceSheetDetails(this.searchText);
          } else {
            this.toastr.error('Unmapping failed');
          }
        }, error: e => {
          this.toastr.error(e.error);
        }
      });
  }

  refreshPreview(isSetKey: boolean = true) {
    const filterDate = structuredClone(this.yearEndDetails.filter(e => e.acctyear === this.selectedYearEnd));
    if (filterDate && filterDate.length) {
      localStorage.setItem('workbookChangeYearEnd', this.countableTimeZonePipe.transform(filterDate[0].acctdate, 'YYYY-MM-DD', 'UTC'));
    }
    this.getPreviousAndCurrentDate();
    if(this.yearEndDetails?.length){
      localStorage.setItem('isLastYear', (this.yearEndDetails[this.yearEndDetails.length - 1].acctyear === this.selectedYearEnd) ? 'true' : 'false');
    }
    localStorage.setItem('workbookChangeDate', this.selectedYearEnd);
    let obj = {
      'currentYear': this.selectedYearEnd,
      'isRefresh': true
    };
    this.sharedService.isBalSheetUpdate.next(obj);
    if (isSetKey) {
      const message = DocumentPreviewTypes.BALANCE_SHEET;
      window.opener.postMessage(message, '*');
      const refreshMap = this.sharedService.setRefreshOfStatement(DocumentPreviewTypes.BALANCE_SHEET);
      this.sharedService.updateFinStatement$.next(refreshMap);
    }
    this.sharedService.refreshWorkbookmenu.next(true);
    if (isSetKey == undefined && !isSetKey) {
      localStorage.setItem('refreshFinancialStatements-BS', 'success');
      localStorage.setItem('refreshTrialbalance', 'success');
    }

    localStorage.removeItem('refreshCashFlow_CF');
    localStorage.setItem('refreshCashFlow_CF', 'refresh');
  }

  clearSelectedData() {
    const parent: HTMLElement = document.querySelector('.cdk-overlay-connected-position-bounding-box');
    if (parent) {
      parent.style['margin-top'] = 0;
    }
    this.groupIds = [];
    this.duplicateIds = [];
    this.selectedTrailBLrow = [];
    this.selectedLSmenuPositions = [];
    this.isDisableMoveButton = true;
    this.activeMapMove = false;
    this.activeLsMove = false;
    this.isindividualRowSave = true;
  }

  resetNotesIs_Checked() {
    if (this.notes && this.notes.length) {
      this.notes.forEach(ele => {
        ele.is_checked = false;
        if (ele.notes) {
          ele.notes.forEach(element => {
            element.is_checked = false;
          });
        }
      });
    }

  }

  notesFSLinkingSelectionDialogFunc(child2?) {
    // this.resetNotesIs_Checked();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.height = '100%';
    dialogConfig.position = {'top': '53px', right: '0'};
    this.changednotesLinks(child2);
    const dialogRef = this.dialog.open(this.notesFSLinkingDialog, dialogConfig);
    dialogRef.afterClosed().subscribe();
  }

  mouseEnterHandler(event: MouseEvent, chapterExpansionPanel: MatExpansionPanel) {
    if (event.buttons && !chapterExpansionPanel.expanded) {
      chapterExpansionPanel.open();
    }
  }

  ngOnDestroy() {
    clearTimeout(this.userActivity);
  }

  filterBalanceSheetDetails(searchTerm) {
    if (!searchTerm) {
      this.balanceSheetDetails = JSON.parse(JSON.stringify(this.originalBalanceSheetDetails.slice()));
      this.isSearchExist = false;
      this.validateSchedules();
    } else {
      let temp = JSON.parse(JSON.stringify(this.originalBalanceSheetDetails.slice()));
      this.balanceSheetDetails = temp.map(group => {
        if (group.children) {
          group.children.forEach(a => {
            if (a.children) {
              a.children.forEach(b => {
                if (b.trialbal) {
                  b.trialbal.forEach(c => {
                    if (c.accountname.toLowerCase().includes(searchTerm.toLowerCase())) {
                      c.isexpand = 'true';
                      b.isexpand = 'true';
                      a.isexpand = 'true';
                      group.isexpand = 'true';
                      this.isHideNotesToFS = true;
                      this.isSearchExist = true;
                      this.balanceSheetDetails = this.balanceSheetDetails.length > 0 ? this.balanceSheetDetails : [];
                      this.unmappedArray = this.balanceSheetDetails.filter(e => e.id == 5);
                      var prev = this.balanceSheetDetails[0]['Prevgrouptotal'];
                      if (prev || prev == 0) {
                        this.isPrevyear = true;
                      } else {
                        this.isPrevyear = false;
                        this.isDisplayCol = false;
                      }
                    } else {
                      c.isexpand = null;
                    }
                  });
                }
              });
            }
          });
        }
        return group;
      });
      this.validateSchedules();
    }
  }

  // current and Previous
  getPreviousAndCurrentDate() {
    const data = this.engService.getPreviousAndCurrentDate(this.yearEndDetails, this.selectedYearEnd);
    this.currentYear = data.currentYear;
    this.selectedYearTitle = data.selectedYearTitle;
    this.previousYear = data.previousYear;
  }

  onDragStarted(event: CdkDragStart): void {
    this.globalListeners.push(
      this.renderer.listen(document, 'mousemove', (e: MouseEvent) => {
        this.currentPointerPosition = {x: e.clientX, y: e.clientY};
      }),
      this.renderer.listen(document, 'touchmove', (e: TouchEvent) => {
        this.currentPointerPosition = {x: e.touches[0].clientX, y: e.touches[0].clientY};
      })
    );

    const container = document.querySelector('.auto-scroll-container') as HTMLElement;
    if (!container) {
      return;
    }

    this.isScrolling = true;

    this.scrollInterval = setInterval(() => {
      if (!this.isScrolling) {
        return;
      }

      const rect = container.getBoundingClientRect();
      const maxSpeed = 50; // Increase max speed for faster scrolling
      let scrollSpeed = 10; // Base speed

      if (this.currentPointerPosition.y > rect.bottom - 60) {
        scrollSpeed = Math.min(scrollSpeed * 2, maxSpeed); // Accelerate scrolling
        container.scrollTop += scrollSpeed;
      } else if (this.currentPointerPosition.y < rect.top + 60) {
        scrollSpeed = Math.min(scrollSpeed * 2, maxSpeed); // Accelerate scrolling
        container.scrollTop -= scrollSpeed;
      }
    }, 10); // Reduce interval for smoother scrolling
  }

  onDragEnded(event: CdkDragEnd): void {
    this.globalListeners.forEach((unlisten) => unlisten());
    this.globalListeners = [];
    this.isScrolling = false;
    clearInterval(this.scrollInterval); // Stop scrolling immediately
  }

  public onResizePanelEnd(resizeData: ResizeModel) {
    resizeData.width < resizeData.minWidth ? this.drawer.close() : '';
  }


  private updateSpinnerConfig(value: boolean) {
      value ? this.spinCount++ : (this.spinCount = Math.max(0, this.spinCount - 1));
      this.spinnerConfig.update((config) => ({ ...config, isSpinShown: this.spinCount > 0 }));
  }

  public addSchedule(child: any) {
    let scheduleList = {
      groupName: null,
      child: [child]
    };
    this.scheduleService.updateScheduleCount('add');
    this.scheduleService.addOrResetSchedules(scheduleList, this.isPrevyear, null, true);
  }

  public deleteSchedule() {
    this.scheduleService.confirmDeleteSchedule(this.selectedSchedule(), DIALOG_TYPES.SCHEDULE);
  }

  public onChangeMatCheckbox() {
    let groups = this.scheduleUtil.onChangeMatCheckbox(this.balanceSheetDetails);
    this.selectedSubGroup.set(groups);
  }

  public createSchedule() {
    const config = this.scheduleUtil.createScheduleGroups(DIALOG_TYPES.GROUP,(this.engagementScheduleDetails().schedulesData?.schedules?.length || 0),this.selectedSubGroup(), true, this.isPrevyear);
    this.dialog.open(SchedulesDialogComponent, config);
  }

  private validateSchedules() {
    this.isAddSchedule.set(this.engagementScheduleDetails()?.scheduleOriginalData?.length >= 0 ? false : true);
    if (this.balanceSheetDetails?.length && this.engagementScheduleDetails().schedulesData?.schedules?.length) {
      const balanceSheetData = this.scheduleUtil.groupByUuid(structuredClone(this.originalBalanceSheetDetails), structuredClone(this.engagementScheduleDetails().scheduleOriginalData));
      const balanceSheetSchedule = this.scheduleUtil.groupBySchedule(structuredClone(balanceSheetData));
      this.balanceSheetDetails = [];
      this.balanceSheetDetails = structuredClone(balanceSheetSchedule);
    }
  }

  private groupAndUnGroup(payload: any[], isGroup: boolean) {
    const path = `/row/custom-group/status?hasCustomGroup=${isGroup}`;
    this.scheduleService.commonPutMethod(path, payload).subscribe();
  }

  private updateSchedulesData(list: any[], isGroup: boolean) {
    const schedules = this.scheduleService.getEngagementSchedule();
    if (list.length && schedules?.scheduleOriginalData?.length) {
      const groupLinkIds = schedules?.scheduleOriginalData.map((schedule: any) => schedule?.groupLinkId);
      const tbIds = this.scheduleUtil.getGroupIdByTbId(list, this.balanceSheetDetails, groupLinkIds);
      tbIds?.length ? this.groupAndUnGroup(tbIds, isGroup) : null;
    }
  }

  viewSchedule(uuid: string){
    this.scheduleService.setSync({uuid: uuid, isSync: true});
  }

}
